import React from 'react';

const achievements = [
  { year: '2025', title: 'NAAC A++ Accreditation', desc: 'Awarded highest grade for academic excellence', icon: '🏆' },
  { year: '2024', title: 'Best Nursing College Award', desc: 'Recognized by State Health Ministry', icon: '🥇' },
  { year: '2023', title: 'Research Innovation Grant', desc: 'Received ₹50L grant for community health research', icon: '🔬' },
  { year: '2022', title: '100% Placement Record', desc: 'Top recruiters from premier hospitals', icon: '📈' },
  { year: '2021', title: 'International Collaboration', desc: 'Partnership with Royal College of Nursing, UK', icon: '🌍' },
  { year: '2020', title: 'Digital Learning Excellence', desc: 'Pioneered hybrid clinical simulation training', icon: '💻' },
];

function Achievements() {
  return (
    <section id="achievements" className="achievements-section">
      <div className="section-container">
        <h2 className="section-title"><span className="title-icon">🏆</span> Our Achievements</h2>
        <div className="achievements-grid">
          {achievements.map((item, i) => (
            <div key={i} className="achievement-card">
              <span className="achievement-icon">{item.icon}</span>
              <span className="achievement-year">{item.year}</span>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Achievements;